var render = function render(){var _vm=this,_c=_vm._self._c;return _c('label',{attrs:{"for":"inputTag"}},[_c('i',{class:_vm.icon}),_vm._v(" "+_vm._s(_vm.name)+" "),_c('input',{attrs:{"id":"inputTag","type":"file"}})])
}
var staticRenderFns = []

export { render, staticRenderFns }